
import React, { useState, useRef } from 'react';
import { useCollapse } from 'react-collapsed';
import { useForm } from 'react-hook-form';
import SignatureCanvas from 'react-signature-canvas';


enum RegisterState{
  unauthorized,
  authorized,
  registered,
}

type Props={
  password:string,
  setRegisterState:(state: RegisterState)=>void,
}

export function RegisterForm({password, setRegisterState}:Props){

  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  const { register, handleSubmit, formState: { errors, isValid } } = useForm({ mode: "onChange" });
  //const [ registered, setRegistered ] = useState(false);
  //const [ wrongPW, setWrongPW ] = useState(false);
  const [ soli, setSoli] = useState<boolean>(false);
  const [ noSig, setNoSig] = useState<boolean>(false);
  const [ noSigSepa, setNoSigSepa] = useState<boolean>(false);

  const sigCanvas = useRef(null);
  const sigCanvasSepa = useRef(null);
  //const onSubmit = handleSubmit(data => {
  //  console.log(data)
  //})
  const onSubmit = async (data:any) => {
    if((sigCanvas?.current as any).isEmpty()){
      setNoSig(true);
      return;
    }
    if((sigCanvasSepa?.current as any).isEmpty()){
      setNoSigSepa(true);
      return;
    }
    const sigData=(sigCanvas?.current as any).toData();
    console.error(sigData);
    data.sigData=sigData;
    const sigDataSepa=(sigCanvasSepa?.current as any).toData();
    data.sigDataSepa=sigDataSepa;
    data.soli = soli ? "true" : "false"; //HACK! why not working regularly?
    data.password=password;
    data.sigWidth=document.getElementsByClassName("sigCanvas")[0].getBoundingClientRect().width;
    data.sigWidthSepa=document.getElementsByClassName("sigCanvasSepa")[0].getBoundingClientRect().width;
    console.log("Form submitted successfully", data);
    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        //setRegistered(true);
        console.log("sending data:",data);
        setRegisterState(RegisterState.registered);
      } else {
        console.log('Error submitting form');
        //setWrongPW(true);
        alert("Fehler! Falsches Passwort trotz vorheriger Prüfung :(");
      }
    } catch (error) {
      console.error('Error:', error);
        alert("upps 1 Server Fehler")
    }
  };
            return(
              <>
            <h2>Mitglied werden</h2>
            <form className='form' action="http://localhost:2222/api/register" onSubmit={handleSubmit(onSubmit)} method="POST">
              <label>Vorname:</label>
              <input type="text" {...register('prename', { required: true })} id="prename" name="prename"/>
              {errors.prename && <p style={{display: "block", textAlign:"left", color: "red"}}>Vorname fehlt.</p>}
              <br/><br/>
              <label>Nachname:</label>
              <input type="text" {...register('name', { required: true })}id="name" name="name"/>
              {errors.name && <p style={{display: "block", textAlign:"left", color: "red"}}>Nachname fehlt.</p>}
              <br/><br/>

              <label>Geburtstag:</label>
              <input
                {...register('birth', {required:true})}
                type="date"
                id="birth"
                name="birth"
                //value=""
                />
              {errors.birth && <p style={{display: "block", textAlign:"left", color: "red"}}>Geburtstdatum fehlt.</p>}
              <br/><br/>


              <label>Email:</label>
              <input type="email" {...register('mail', { 
                required: true,
                pattern: {
                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                  message: "Ungültige Email-Adresse"
                }
              })}/>
              {errors.mail && <p style={{display: "block", textAlign:"left", color: "red"}}>Ungültige Email-Adresse</p>}
              <br/><br/>
              <fieldset>
                <legend>Sepa</legend>
                <br></br>
                <label>Straße:</label>
                <input type="text" {...register('street', { required: true })}id="street" name="street"/>
                {errors.street && <p style={{display: "block", textAlign:"left", color: "red"}}>Straße fehlt.</p>}
                <br/><br/>
                <label >Nr:</label>
                <input type="text" inputMode="numeric" {...register('number', { required: true })}id="number" name="number"/>
                {errors.number && <p style={{display: "block", textAlign:"left", color: "red"}}>Hausnummer fehlt.</p>}
                <br/><br/>
                <label>PLZ:</label>
                <input type="text" inputMode="numeric" {...register('plz', { required: true })}id="plz" name="plz"/>
                {errors.plz && <p style={{display: "block", textAlign:"left", color: "red"}}>Postleitzahl fehlt.</p>}
                <br/><br/>
                <label >Ort:</label>
                <input type="text" {...register('city', { required: true })}id="city" name="city"/>
                {errors.city && <p style={{display: "block", textAlign:"left", color: "red"}}>Stadt fehlt.</p>}
                <br/><br/>
                <label>IBAN:</label>
                <input type="text" {...register('iban', { 
                  required: "IBAN fehlt.", 
                  pattern: {
                    value: /^[A-Za-z]{2}\d{20}$/,
                    message: "Ungültige IBAN"
                  }
                })}/>
                {errors.iban && <p style={{display: "block", textAlign:"left", color: "red"}}>Ungültige IBAN<br></br> (bitte ohne Leerzeichen angeben)</p>}
                <br/><br/>
                <label>BIC:</label>
                <input type="text" {...register('bic', { required: true })}id="bic" name="bic"/>
                {errors.bic && <p style={{display: "block", textAlign:"left", color: "red"}}>BIC fehlt.</p>}
                <br/><br/>


              <input type="hidden" id="soli"  {...register('soli')} value={soli?"true":"false"} name="soli"/>
              <div>
              <button
                  type="button"
                  className={"soli"+(!soli?" soli--unselected":"")}
                  style={{
                    borderRadius: "15px 0px 0px 15px", 
                    borderRight:"2px solid #FF89D5",
                    width: "50%",
                    backgroundColor: (soli?"#FF89D5":"#FFEC01"),
                  }}
                  onClick={() => setSoli(true)}
              >
                <p style={{margin: "0px", fontWeight: "bold"}}>
                Soli:
                </p>
                5€ pro Monat
              </button>
              <button
                  type="button"
                  className={"soli"+(soli?" soli--unselected":"")}
                  style={{
                    borderRadius: "0px 15px 15px 0px", 
                    borderLeft:"2px solid #FF89D5",
                    width: "50%",
                    backgroundColor: (!soli?"#FF89D5":"#FFEC01"),
                  }}
                  onClick={() => setSoli(false)}
              >
                <p style={{margin: "0px", fontWeight: "bold"}}>
                  Regulär:
                </p>
                10€ pro Monat
              </button>
              </div>
                <br/><br/>


                <label style={{display: "inline-block", fontSize: "16px", width: "50%", textAlign:"center", overflowWrap:"break-word",verticalAlign: "top"}}>
                  Gläubiger-Identifikationsnummer:
                  <br/>
                  DE53ZZZ00000568978
                </label>
                <label style={{display: "inline-block", fontSize: "16px", width: "50%", textAlign:"center", overflowWrap:"break-word",verticalAlign: "top"}}>
                  Mandatsreferenz: 
                  <br/>
                  113356849
                </label>
                <br/>
                <br/>
                <input type="checkbox" {...register('checkbox', { required: true })}
                //style={{display: "inline-bock", width:"40%", maxWidth:"240px", verticalAlign: "top", aspectRatio: "1 / 1"}}
                />
                {/*
                <input type="checkbox" {...register('checkbox', {validate: (value) => value === true || 'You must accept the terms', required:true})} style={{display: "inline-bock", width:"40%", maxWidth:"240px", verticalAlign: "top", aspectRatio: "1 / 1"}}/>
                */}
                {!isExpanded&&<div className="sepa-big">
                  Ich akzeptiere das Sepa Lastschriftmandat.
                    <span style={{cursor: "pointer", textDecoration: "underline"}} onClick={getToggleProps().onClick}>
                    {isExpanded ? "" : " mehr>>"}
                    </span>
                </div>
                }
                {isExpanded&&<div className="sepa-small">
                  <section {...getCollapseProps()}
                  >
                    Hiermit ermächtige ich den Verein Kneipenchor Linden e.V., Zahlungen von meinem Konto
                    mittels Lastschrift einzuziehen. Zugleich weise ich mein Kreditinstitut
                    an, die vom Kneipenchor Linden e.V. auf mein Konto gezogenen Lastschriften einzulösen.
                    Hinweis: Dieses Lastschriftmandat dient nur dem Einzug von Lastschriften, die auf Konten
                    des Kneipenchor Lindens e.V. gezogen sind. Ich bin nicht berechtigt, nach der erfolgten
                    Einlösung eine Erstattung des belasteten Betrages zu verlangen. Ich bin
                    berechtigt, mein Kreditinstitut bis zum Fälligkeitstag anzuweisen, Lastschriften
                    nicht einzulösen.
                  </section>
                </div>
              }
              {errors.checkbox && <p style={{display: "block", textAlign:"left", color: "red"}}>Wir brauchen eure Zustimmung!</p>}

            <label style={{width: "50%", display: 'inline-block'}}>Digitale Unterschrift Sepa-Mandat:</label>
            <button type="button" onClick={()=>{(sigCanvasSepa?.current as any)?.clear()}} style={{marginBottom:"1%",width: "50%", padding:"10px", display: 'inline-block'}}>Nochmal von vorn</button>
            <SignatureCanvas penColor="#014479" canvasProps={{ className: "sigCanvasSepa" }} ref={sigCanvasSepa} />
            {noSigSepa && <p style={{display: "block", textAlign:"left", color: "red"}}>Wir brauchen deine Unterschrift.</p>}


              </fieldset>
              <br></br>

            <label style={{width: "50%", display: 'inline-block'}}>Digitale Unterschrift Vereinsbeitritt*:</label>
            <button type="button" onClick={()=>{(sigCanvas?.current as any)?.clear()}} style={{marginBottom:"1%",width: "50%", padding:"10px", display: 'inline-block'}}>Nochmal von vorn</button>
            <SignatureCanvas penColor="#014479" canvasProps={{ className: "sigCanvas" }} ref={sigCanvas} />
            <p>*mit dieser Unterschrift stimme ich der Verarbeitung meiner Daten im Sinne des Vereins zu.</p>
            {noSig && <p style={{display: "block", textAlign:"left", color: "red"}}>Wir brauchen deine Unterschrift.</p>}
            <br></br>
            <br></br>
            <input type="submit" value="Abschicken!" /*disabled={!isValid}*/ />

            </form>
            <br></br>
            <br></br>
            <br></br>
            <a style={{color: "#FF89D5"}} href="https://kneipenchor-linden.de/satzung.pdf">Satzung herunterladen</a>
            </>

            );


}
export default RegisterForm;
